import type React from 'react';
import { useCookies } from 'react-cookie';
import { localeArray as locales } from '../../../../../constants/LocaleConstants';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useRouter } from 'next/router';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@lb-service/ui';

const LangMenu: React.FC = () => {
  const router = useRouter();
  const currentLocale = router.locale;
  const locale =
    locales.find((loc) => loc.value === currentLocale) ?? locales[0];
  const language = locale.language;
  const [_cookies, setCookie] = useCookies(['NEXT_LOCALE']);
  const switchLang = (value: string) => {
    if (value === currentLocale) return;
    const pathname = router.asPath;
    const newLocale = locales.find((loc) => loc.value === value);
    if (process.env.NODE_ENV === 'production') {
      (window as any).location =
        `https://${newLocale.subdomain}.lingualbox.com${pathname}`;
    } else {
      (window as any).location =
        `http://${newLocale.subdomain}.lingualbox.loc:3002${pathname}`;
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <a
          className="text-default hover:text-default flex items-center font-medium cursor-pointer"
          onClick={(e) => e.preventDefault()}
        >
          {language}
          <ChevronDownIcon className="ml-1 text-default h-4 w-4" />
        </a>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {locales.map((loc) => (
          <DropdownMenuItem
            key={`locale-${loc.language}`}
            onClick={() => switchLang(loc.value)}
          >
            {loc.language}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LangMenu;
